export const environment = {
  production: true,
  buildId: '3764397121523371',
  configFile: 'config.json',
};
